{
  "settings": "Cài đặt",
  "yourDigitalAssistant": "Trợ lý kỹ thuật số của bạn",
  "getStarted": "Bắt đầu",
  "login": "Đăng nhập",
  "loggingIn": "Đang đăng nhập…",
  "darkMode": "Chế độ tối",
  "clearHistory": "Xóa lịch sử",
  "historyCleared": "Lịch sử đã xóa",
  "changeLanguage": "Ngôn ngữ",
  "termsAndConditions": "Điều khoản và điều kiện",
  "messagePlaceholder": "Gõ tin nhắn của bạn ở đây ...",
  "messagePlaceholderDisabled": "Gõ tin nhắn bị vô hiệu hóa",
  "feedbackTitle": "Đánh giá trải nghiệm của bạn",
  "feedbackPlaceholder": "Hãy chia sẻ với chúng tôi về trải nghiệm này (Tùy chọn)",
  "feedbackSend": "Gửi",
  "feedbackClose": "Đóng",
  "sessionExpired": "Phiên trò chuyện của bạn đã hết hạn do không hoạt động.",
  "startNewSession": "Bắt đầu phiên trò chuyện mới",
  "apiError": "Oops! Đã xảy ra lỗi. Chúng tôi đang cố gắng khắc phục điều này sớm nhất có thể.",
  "apiErrorOffline": "Bạn đang không kết nối với Internet.",
  "tryAgain": "Thử lại",
  "startOver": "Bắt đầu lại",
  "chatEnded": "Trò chuyện đã kết thúc.",
  "chatEndedThankYou": "Cảm ơn bạn đã trò chuyện với chúng tôi!",
  "closeChat": "Đóng",
  "startNewChat": "Trò chuyện lại",
  "humanTakeoverStarted": "Bạn đang được kết nối với Nhân Viên Dịch Vụ Khách Hàng ...",
  "humanTakeoverQueued": "Đang chờ kết nối với Nhân Viên Dịch Vụ Khách Hàng",
  "humanTakeoverAnAgent": "Nhân Viên Dịch Vụ Khách Hàng",
  "humanTakeoverAgentEntered": "Đã tham gia cuộc trò chuyện",
  "humanTakeoverAgentLogout": "Đã rời khỏi cuộc trò chuyện",
  "humanTakeoverTransfer": "Bạn đang được kết nối với Nhân Viên Dịch Vụ Khách Hàng khác",
  "humanTakeoverEnded": "Bạn đang trò chuyện với trợ lý kỹ thuật số của bạn",
  "version": "Phiên bản",
  "formIntroText": "Vui lòng điền vào mẫu sau để bắt đầu trò chuyện với chúng tôi.",
  "formFirstName": "Tên",
  "formLastName": "Họ",
  "formName": "Tên",
  "formEmail": "Địa chỉ thư điện tử",
  "formWrongEmail": "Vui lòng cung cấp một địa chỉ email hợp lệ.",
  "formPhone": "Điện thoại",
  "formShipmentId": "Số vận đơn của lô hàng",
  "formQuestion": "Câu hỏi của bạn",
  "formAccountNumber": "Số tài khoản (dành cho Khách hàng Doanh nghiệp)",
  "formAddress": "Địa chỉ",
  "formPostcode": "Mã bưu điện",
  "formCity": "thành phố",
  "formCountry": "Quốc gia",
  "formSubmitButton": "Bắt đầu trò chuyện",
  "formEmptyFieldError": "Không được để trống.",
  "formPhoneNumberValidationError": "Số điện thoại không hợp lệ",
  "formInputIsBiggerThan50": "Chỉ chứa tối đa 50 ký tự.",
  "formInputIsBiggerThan100": "Chỉ chứa tối đa 100 ký tự.",
  "formInputIsBiggerThan2000": "Chỉ chứa tối đa 2000 ký tự.",
  "widgetEventOnline": "Thông báo DA: Người dùng đã trực tuyến trở lại.",
  "widgetEventHidden": "Thông báo DA: Widget bị ẩn.",
  "widgetEventVisible": "Thông báo DA: Widget hiển thị.",
  "WidgetEventVisibleMinimized": "Thông báo DA: Tiện ích có thể nhìn thấy, nhưng được thu nhỏ.",
  "widgetEventMinimized": "Thông báo DA: Widget được thu nhỏ.",
  "widgetEventMaximized": "Thông báo DA: Widget được tối đa hóa.",
  "widgetEventSessionExpired": "Thông báo DA: Phiên widget đã hết hạn.",
  "widgetEventHangupHuman": "Thông báo DA: Người dùng kết thúc Phiên tiếp quản của con người.",
  "widgetEventUserTyping": "Thông báo DA: người dùng đang nhập.",
  "fileTooLarge": "Bạn Đang Cố Đính kèm Các Tập Tin Quá Lớn.",
  "tooManyDiles": "Bạn Đang Cố Đính kèm Quá Nhiều Tệp.",
  "fileInvalidType": "Bạn Đang Cố Đính kèm Các Loại Tệp Không Hợp lệ.",
  "attachmentsDropHere": "Thả vào đây để tải lên hoặc",
  "attachmentsBrowse": "Duyệt tệp",
  "attachmentsExtenstionQuantity": "pdf hoặc hình ảnh (tối đa 10 tệp)",
  "attachmentsSize": "lên đến 30 MB",
  "attachmentsFailedUploading": "Tải lên không thành công",
  "attachmentsUploading": "Đang tải lên ...",
  "minimizeExpandText": "Trò chuyện trực tiếp với chúng tôi ngay bây giờ!",
  "popupWidgetNotificationMessage": "Bạn đã nhận được một tin nhắn mới!",
  "tabWidgetNotificationMessage": "Tin nhắn mới!",
  "datepickerSendButton": "gửi"
}
